export const NewOrderLsKeys = {
  NEW_ORDER_DRAFT: "client-new-order-draft",
  DUPLICATE_ORDER_DRAFT: "client-duplicate-order-draft",
  EXTEND_ORDER_DRAFT: "client-extend-order-draft",
  PROMOTE_ORDER_DRAFT: "client-promote-order-draft",
} as const;

export type TNewOrderLsKeys =
  (typeof NewOrderLsKeys)[keyof typeof NewOrderLsKeys];
